import { render, staticRenderFns } from "./KarmanVortexViz.vue?vue&type=template&id=ee4ca304&scoped=true"
import script from "./KarmanVortexViz.vue?vue&type=script&lang=js"
export * from "./KarmanVortexViz.vue?vue&type=script&lang=js"
import style0 from "./KarmanVortexViz.vue?vue&type=style&index=0&id=ee4ca304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ca304",
  null
  
)

export default component.exports